export default __webpack_public_path__ + "static/media/money-bill.8ace7ab8.svg";